// These routes carry a booking uid or a private link hash in the path, which grants access
// to the booking without logging in, so it must never reach PostHog.
const TOKENIZED_ROUTES = new Set([
  "booking",
  "booking-successful",
  "confirmar",
  "deposito",
  "payment",
  "video",
  "reschedule",
  "d",
]);

export function sanitizePath(pathname: string): string {
  const segments = pathname.split("/");
  const tokenIndex = segments.findIndex((segment) => TOKENIZED_ROUTES.has(segment)) + 1;
  if (tokenIndex === 0 || !segments[tokenIndex]) return pathname;
  segments[tokenIndex] = ":uid";
  return segments.join("/");
}

// Booking pages prefill name, email and notes through the query string, so only UTM params survive.
export function sanitizeUrl(rawUrl: string): string {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return rawUrl;
  }
  const kept = new URLSearchParams();
  url.searchParams.forEach((value, key) => {
    if (key.startsWith("utm_")) kept.append(key, value);
  });
  const query = kept.toString();
  return `${url.origin}${sanitizePath(url.pathname)}${query ? `?${query}` : ""}`;
}
